import { render, staticRenderFns } from "./PlantillasEstudios.vue?vue&type=template&id=a0e8fe2a&scoped=true"
import script from "./PlantillasEstudios.vue?vue&type=script&lang=js"
export * from "./PlantillasEstudios.vue?vue&type=script&lang=js"
import style0 from "./PlantillasEstudios.vue?vue&type=style&index=0&id=a0e8fe2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e8fe2a",
  null
  
)

export default component.exports